<div id="navigationPanel" class="navigationPanel">
    <div *ngIf="eForm" cdkDropList class="dropList" (cdkDropListDropped)="dropTab($event)"
        [cdkDropListData]="eForm.Tabs">
        <div *ngFor="let tab of eForm.Tabs" cdkDrag class="dropItem" cdkDragLockAxis="y" [cdkDragData]="tab">
            <div class="nodeRow" (click)="tabClick(tab)" *ngIf="config.AllowTabs">
                <button mat-icon-button cdkDragHandle style="cursor:move;">
                    <img id='imgGrip' alt='Drag to Reorder' aria-label='Drag to Reorder'
                        src='./assets/images/grip.png'/>
                </button>
                <div class="node"
                    [ngStyle]="{'background-color': selectedTab == tab && selectedElementType == 'tab' ? '#ffe597' : ''}">
          <span aria-label="Expand row for more details" style="width:25px;">
            <i [ngClass]="tab.Expanded ? 'detail-row-expanded-icon' : 'detail-row-collapsed-icon'" class="material-icons"
                (click)="toggleNode(tab)"
                aria-hidden="true"></i>
          </span>
                    &nbsp;Tab - {{tab.Name}}
                    <div class="toolbar">
                        <button mat-icon-button (click)="editClick()"><img id='imgEdit' alt='Edit Tab'
                            aria-label='Edit Tab'
                            src='./assets/images/edit.png'/></button>
                        <button mat-icon-button (click)="deleteClick('Tab')"><img id='imgDelete' alt='Remove Tab'
                            aria-label='Remove Tab'
                            src='./assets/images/trash.png'/></button>
                    </div>
                </div>
            </div>
            <div *ngIf="tab.Expanded" cdkDropList class="dropList" (cdkDropListDropped)="dropPage($event)"
                [cdkDropListData]="tab.Pages">
                <div *ngFor="let page of tab.Pages" cdkDrag class="dropItem" cdkDragLockAxis="y" [cdkDragData]="page">
                    <div class="nodeRow" (click)="pageClick(page)" *ngIf="config.AllowPages">
                        <button mat-icon-button cdkDragHandle style="cursor:move;">
                            <img id='imgGrip' alt='Drag to Reorder' aria-label='Drag to Reorder'
                                src='./assets/images/grip.png'/>
                        </button>
                        <div style="margin-left:20px;" class="node"
                            [ngStyle]="{'background-color': selectedPage == page && selectedElementType == 'page' ? '#ffe597' : ''}">
              <span aria-label="Expand row for more details" style="width:25px;">
                <i [ngClass]="page.Expanded ? 'detail-row-expanded-icon' : 'detail-row-collapsed-icon'" class="material-icons"
                    (click)="toggleNode(page)" aria-hidden="true"></i>
              </span>
                            &nbsp;Page - {{page.Name}}
                            <div class="toolbar">
                                <button mat-icon-button (click)="editClick()"><img id='imgEdit' alt='Edit Page'
                                    aria-label='Edit Page'
                                    src='./assets/images/edit.png'/></button>
                                <button mat-icon-button (click)="deleteClick('Page')"><img id='imgDelete'
                                    alt='Remove Page'
                                    aria-label='Remove Page' src='./assets/images/trash.png'/></button>
                            </div>
                        </div>
                    </div>
                    <div *ngIf="page.Expanded" style="padding-left:60px;">
                        <div *ngFor="let column of page.Columns" style="flex:1;">
                            <ng-content *ngTemplateOutlet='colNode;context:{column:column}'></ng-content>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<ng-template #rowNode let-row='row'>
    <div style="padding-left:20px">
        <div class="nodeRow" (click)="rowClick(row)">
            <div class="node"
                [ngStyle]="{'background-color': selectedRow == row && selectedElementType == 'row' ? '#ffe597' : ''}">
        <span aria-label="Expand row for more details" style="width:25px;">
          <i [ngClass]="row.Expanded ? 'detail-row-expanded-icon' : 'detail-row-collapsed-icon'" class="material-icons"
              (click)="toggleNode(row)"
              aria-hidden="true" *ngIf="row.Controls.length > 0 || row.Columns.length > 0"></i>
        </span>
                &nbsp;Row
                <div class="toolbar">
                    <button mat-icon-button (click)="copyRowClick()"><img id='imgCopy' alt='Copy Element'
                        style="height: 25px; width: 25px;" aria-label='Copy Element'
                        src='./assets/images/Google content-copy icon.png'/></button>

                    <button mat-icon-button (click)="editClick()"><img id='imgEdit' alt='Edit Row' aria-label='Edit Row'
                        src='./assets/images/edit.png'/></button>
                    <button mat-icon-button (click)="deleteClick('Row')"><img id='imgDelete' alt='Remove Row'
                        aria-label='Remove Row'
                        src='./assets/images/trash.png'/></button>
                </div>
            </div>
        </div>
        <ng-container *ngIf="row.Expanded">
            <div *ngFor='let control of row.Controls' style="padding-left:45px;" (click)="controlClick(control)"
                class="nodeRow">
                <div class="node"
                    [ngStyle]="{'background-color': selectedControl == control && selectedElementType == 'control' ? '#ffe597' : ''}">
                    <tyl-quill-text-only [padding]="0"
                        [html]="control | getDesignerControlName"
                        style="display:flex;"></tyl-quill-text-only>
                    <span *ngIf="control.ControlType != 'text'">{{control | getDesignerControlName}}</span>
                    <div class="toolbar">
                        <button mat-icon-button (click)="editClick()"><img id='imgEdit' alt='Edit Control'
                            aria-label='Edit Control'
                            src='./assets/images/edit.png'/></button>
                        <button mat-icon-button (click)="deleteClick('Control')"><img id='imgDelete'
                            alt='Remove Control' *ngIf="!control.CannotBeRemoved"
                            aria-label='Remove Control' src='./assets/images/trash.png'/></button>
                    </div>
                </div>
            </div>
            <ng-container *ngFor='let col of row.Columns'>
                <ng-content *ngTemplateOutlet='colNode;context:{column:col}'></ng-content>
            </ng-container>
        </ng-container>
    </div>
</ng-template>

<ng-template #colNode let-column='column'>
    <div style="padding-left:20px">
        <div class="nodeRow" (click)="columnClick(column)">
            <div class="node"
                [ngStyle]="{'background-color': selectedColumn == column && selectedElementType == 'column' ? '#ffe597' : ''}">
          <span aria-label="Expand row for more details" style="width:25px;">
              <i [ngClass]="column.Expanded ? 'detail-row-expanded-icon' : 'detail-row-collapsed-icon'" class="material-icons"
                  (click)="toggleNode(column)" aria-hidden="true"
                  *ngIf="column.Controls.length > 0 || column.Rows.length > 0"></i>
            </span>
                &nbsp;
                Column
                <div class="toolbar">
                    <button mat-icon-button (click)="copyColumnClick()"><img id='imgCopy' alt='Copy Element'
                        style="height: 25px; width: 25px;" aria-label='Copy Element'
                        src='./assets/images/Google content-copy icon.png'/></button>

                    <button mat-icon-button (click)="editClick()"><img id='imgEdit' alt='Edit Column'
                        aria-label='Edit Column'
                        src='./assets/images/edit.png'/></button>
                    <button mat-icon-button (click)="deleteClick('Column')"><img id='imgDelete' alt='Remove Column'
                        aria-label='Remove Column' src='./assets/images/trash.png'/></button>
                </div>
            </div>
        </div>
        <ng-container *ngIf="column.Expanded">
            <div *ngFor='let control of column.Controls' style="padding-left:45px" (click)="controlClick(control)"
                class="nodeRow">
                <div class="node"
                    [ngStyle]="{'background-color': selectedControl == control && selectedElementType == 'control' ? '#ffe597' : ''}">
                    <div *ngIf="control.ControlType == 'text'" [innerHtml]='control | getDesignerControlName | safeHtml'
                        style="display:flex;"></div>
                    <span *ngIf="control.ControlType != 'text'">{{control | getDesignerControlName}}</span>
                    <div class="toolbar">
                        <button mat-icon-button (click)="editClick()"><img id='imgEdit' alt='Edit Control'
                            aria-label='Edit Control'
                            src='./assets/images/edit.png'/></button>
                        <button mat-icon-button (click)="deleteClick('Control')"><img id='imgDelete'
                            alt='Remove Control'
                            aria-label='Remove Control' src='./assets/images/trash.png'/></button>
                    </div>
                </div>
            </div>
            <ng-container *ngFor='let row of column.Rows'>
                <ng-content *ngTemplateOutlet='rowNode;context:{row:row}'></ng-content>
            </ng-container>
        </ng-container>
    </div>
</ng-template>
